import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function QuestionList() {
  const [quizIds, setQuizIds] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await fetch('/api/quiz');
        if (!response.ok) {
          throw new Error('Failed to fetch questions');
        }
        const data = await response.json();
        setQuizIds(data);
      } catch (err) {
        setError('Could not contact the backend');
        console.error(err);
      }
    };

    fetchQuestions();
  }, []);

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="question-list">
      <h1>Available Questions ({quizIds.length})</h1>
      <ul>
        {quizIds.map((id) => (
          <li key={id}>
            <Link to={`/quiz/${id}`}>
              {id}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
